<template>

    <!-- Login Header Start -->
    <div class="section login-header">
        <!-- Login Header Wrapper Start -->
        <div class="login-header-wrapper navbar navbar-expand">

            <!-- Header Logo Start -->
            <div class="login-header-logo dashboard-brand">
                <a href="index.html" class="dashboard-brand-link">
                    <img src="/assets/images/logo-icon.png" alt="Logo">
                    <span class="dashboard-brand-text">COLREGs</span>
                </a>
            </div>
            <!-- Header Logo End -->

            <!-- Header Search Start -->
            <div class="login-header-search dropdown">

            </div>
            <!-- Header Search End -->

            <!-- Header Action Start -->
            <div class="login-header-action ml-auto">

                <div class="action author profile-menu" ref="profileMenu">
                    <div class="user-profile-icon cap cursor-pointer" v-if='email' :title="email" @click.stop="toggleProfilePopover">{{email.charAt(0)}}</div>

                    <transition name="fade">
                        <div class="profile-popover" v-if="showProfilePopover" @click.stop>
                            <div class="profile-popover-avatar cap">{{email ? email.charAt(0) : ''}}</div>
                            <div class="profile-popover-details">
                                <p class="profile-popover-name cap">{{ fullName || 'User' }}</p>
                                <p class="profile-popover-email">{{ email }}</p>
                            </div>
                        </div>
                    </transition>
                </div>

                <a class="cursor-pointer" ><svg title="logout" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" width="28" height="28" @click="logout" class='logout' color="white">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg></a>
            </div>
            <!-- Header Action End -->

        </div>
        <!-- Login Header Wrapper End -->
    </div>
    <!-- Login Header End -->

</template>

<script>
import { jwtDecode } from "jwt-decode";
import { getUserDetails } from '@/services/userService';

export default {
    name: 'DashboardHeader',
    data() {
        return {
            is_logged_in: false,
            role: null,
            email: null,
            fullName: null,
            showProfilePopover: false
        }
    },

    mounted() {
        this.check_if_logged_in();
        document.addEventListener('click', this.handleOutsideClick);
    },

    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    },

    watch: {
        '$route': 'check_if_logged_in',
    },

    methods: {

        check_if_logged_in() {
            const token = localStorage.getItem('access_token');
            if (token) {
                try {
                    const decoded = jwtDecode(token);
                    // console.log(decoded);
                    this.is_logged_in = true;
                    this.role = decoded.role;
                    this.email = decoded.email;
                    this.getFullName();
                } catch (error) {
                    console.error("Invalid token:", error);
                    this.logout();
                }
            } else {
                this.logout();
            }
        },

        async getFullName() {
            try {
                const user = await getUserDetails(this.email);
                this.fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
            } catch (error) {
                console.error('Error fetching user details:', error);
            }
        },

        toggleProfilePopover() {
            this.showProfilePopover = !this.showProfilePopover;
        },

        handleOutsideClick(event) {
            if (this.showProfilePopover && this.$refs.profileMenu && !this.$refs.profileMenu.contains(event.target)) {
                this.showProfilePopover = false;
            }
        },

        logout() {
            localStorage.removeItem('access_token');
            this.is_logged_in = false;
            this.role = null;
            this.$router.push({ name: 'Login' });
        }
    }
};
</script>
<style scoped>
.cap{
    text-transform: capitalize;
}
.cursor-pointer{
    cursor: pointer;
}
.dashboard-brand-link{
    display: flex;
    align-items: center;
    gap: 10px;
}
.dashboard-brand-text{
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.profile-menu{
    position: relative;
}

.profile-popover{
    position: absolute;
    top: calc(100% + 16px);
    right: 0;
    min-width: 240px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1000;
}

.profile-popover::before{
    content: '';
    position: absolute;
    top: -6px;
    right: 22px;
    width: 12px;
    height: 12px;
    background: #fff;
    transform: rotate(45deg);
    box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.04);
}

.profile-popover-avatar{
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: #309255;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 18px;
}

.profile-popover-details{
    min-width: 0;
}

.profile-popover-name{
    margin: 0 0 4px;
    font-size: 15px;
    font-weight: 600;
    color: #212832;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.profile-popover-email{
    margin: 0;
    font-size: 13px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fade-enter-active,
.fade-leave-active{
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.fade-enter-from,
.fade-leave-to{
    opacity: 0;
    transform: translateY(-6px);
}
</style>